/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type editor_editorPropertiesOverride$ref: FragmentReference;
export type editor_editorPropertiesOverride = {|
  +rtlSupport: ?boolean,
  +newCkeditor: ?boolean,
  +ckeditor5: ?boolean,
  +ckeditor5AiEnabled: ?boolean,
  +newSpellcheckEnabled: ?boolean,
  +newSpellcheckTenantDictionaryName: ?string,
  +ckeditor5LicenseKey: ?string,
  +contentDirection: ?string,
  +$refType: editor_editorPropertiesOverride$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "editor_editorPropertiesOverride",
  "type": "DocumentOverrideType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "rtlSupport",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "newCkeditor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "ckeditor5",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "ckeditor5AiEnabled",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "newSpellcheckEnabled",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "newSpellcheckTenantDictionaryName",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "ckeditor5LicenseKey",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "contentDirection",
      "args": null,
      "storageKey": null
    }
  ]
};

(node/*: any*/).hash = '922fabc050a7fd5c7569ca3f7323450d';
module.exports = node;
